<template>
  <div>
  <b-jumbotron class="bg-light" style="padding: 2rem; border-radius: 15px;">
    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
    <b-card class="shadow-lg" style="width: 30rem; border-radius: 15px; background: linear-gradient(135deg, #ffffff, #f8f9fa);">
    <b-row>
      <b-col  cols="12" sm="12"	md="12"	lg="12"	xl="1"> 
        <img src="images/logo_gmail.png" alt="Icono" style="width: 34px; height: 30px;">
      </b-col>
      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="10">
        <div>
          <b-form-text
            style="font-size: small !important; color: black !important"
            > Este comprobante se enviará automáticamente a los siguientes correos:
          </b-form-text>
        </div>
        <div class="float-right">
          <template v-if="cargandoEmailNegocio">
            <i class="fas fa-spin fa-spinner"></i><strong> Cargando correo...</strong>
          </template>
          <template v-else-if="emailNegociosVista ==[]">
            <i class="fas fa-spin fa-spinner"></i><strong> Sin correos</strong>
          </template>
          <template v-else>
            <h5>
              <li  class="mr-1" variant="dark" v-for="(item,index) in emailNegociosVista" :key="index">
              <b-badge pill variant="light">{{item}}
              <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
              </li>
            </h5>
          </template>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="1"></b-col>
      <b-col  cols="12" sm="12"	md="12"	lg="12"	xl="10">
        <template v-if="emailNegocios.length>0 "> 
          <b-form-text
            style="font-size: small !important; color: black !important"
            > Correos adicionales:
          </b-form-text>
            <h5>
              <li  class="mr-1" variant="dark" v-for="(item,index) in emailNegocios" :key="index">
              <b-badge pill variant="light">{{item}}
              <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
              </li>
            </h5>
        </template>
        <b-input-group>
          <b-form-input 
            placeholder="Agregar correo"
            style="border-color:black" 
            v-model="email" 
            type="email" 
            @keyup.enter="addEmail">
          </b-form-input>
          <b-input-group-append>
            <b-button @click="addEmail" variant="outline-primary">Agregar</b-button>
          </b-input-group-append>
          </b-input-group>
          <b-form-text 
            style="font-size: small !important; color: black !important"
            >Ingresa un correo y presiona Enter o el botón Agregar
          </b-form-text>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <!-- <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
        <div class="text-center">
          <b-form-checkbox
            switch
            v-model="activo"
            :value="true"
            :unchecked-value="false"
            size="lg"
            @change="banderaPdf">
            {{ activo ? 'Sí' : 'No' }}
          </b-form-checkbox>
        </div>
        <b-form-text class="text-center"
          style="font-size: small !important; color: black !important"
          > ¿Mostrar PDF luego de emitir?
        </b-form-text>
      </b-col> -->
    </b-row>
    </b-card>
    </div>
  </b-jumbotron>
  </div>
</template>
  <script>
  import axios from "axios";
  export default {
    name: 'EnviarComprobantes',
    props: {listaCorreos:Array},
    components: {},
    data() {
      return {
        numeroWhatsApp: '',
        email: '',  
        emailNegocios:[],
        emailNegociosVista:[],
        // dataFactura: {},
        pdfobject: '',
        cargandoEmailNegocio: false,
        // activo: true,
      };
    },
    mounted(){
      // this.respuestaFactura();
      this.$parent.$on("comprobanteEmitido", (data) => {
      console.log(data);
      // this.enviarEmail();
      if(this.emailNegocios.length>0){
        this.enviarEmailNegocios(data);
      }else{
        this.emailNegocios = [];
      }
      
    });
    },
    watch: {
      listaCorreos(newVal) {
        this.emailNegociosVista = newVal;
      }
    },
    methods: {
      // respuestaFactura() {
      //   // this.dataFactura =  this.$store.getters.getRespuestaFactura;
      //   // this.activo = this.$store.getters.getBanderaPDF;
      //   // this.banderaPdf(this.activo);
      // },
      // enviarEmail: function() {
      //   if (!this.validarCorreo(this.email)) {
      //       this.$snotify.warning("El correo ingresado no es válido", "Cuidado!");
      //     return;
      //   }
      //   axios
      //     .post(process.env.VUE_APP_API_URL + "facturas/mail", {
      //       token: this.$store.getters.userToken,
      //       id: this.dataFactura.idFactura,
      //       mail: this.email
      //     })
      //     .then(response => (this.email = '', this.$snotify.success(response.data.msg, "Exito")))
      //     .catch(error => (this.$snotify.error(error.response.data.response, "Error")));
      // },
      validarCorreo: function(correo) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar correos
        return regex.test(correo); // Retorna true si el correo es válido
      },
      enviarEmailNegocios: function(data) {
          for (let i = 0; i < this.emailNegocios.length; i++) {
                this.emailNegocios[i] + ","
            }
            let cadena = this.emailNegocios.join(",");
            axios
              .post(process.env.VUE_APP_API_URL + "facturas/mail", {
                token: this.$store.getters.userToken,
                id: data.response.idFactura,
                mail: cadena
              })
              .then(response => (this.emailNegocios = [], this.$snotify.success(response.data.msg, "Exito")))
              .catch(error => (this.$snotify.error(error.response.data.response, "Error")));
      }, 
      borrarCorreo(index){
        this.emailNegocios.splice(index, 1)
      },
      addEmail(){
        this.emailNegocios.push(this.email);
        this.email = '';
      },
      // banderaPdf(valor) {
      //   this.$store.commit("banderaPDF", valor)
      //   this.$emit('mostrarPdf', valor)
      // },
    },
  };
  </script>
  <style scoped>
 
  </style>